import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavBar } from '../../../components/essentials/navbar/navbar.component';
import { Footer } from '../../../components/essentials/footer/footer.component';
import { Getstarted } from '../../../components/essentials/get-started/getstarted.component';
import { OverlapBoxTechno } from '../techno.component';
import phoneImg1 from '../../../assest/phoneImg/Face Based.png';
import phoneImg2 from '../../../assest/phoneImg/Liveness Detection.png';
import './face-based.styles.scss';
import TrackedSection from '../../../components/essentials/google/GoogleAnalytics';

export const FaceBased = () => {
  const { t } = useTranslation('biometrics');

  return (
    <div className='blogs-main'>
      <NavBar />
      <HeaderHalf title={t('headerTitle')} uris={t('headerUri')} />

      <OverlapBoxTechno img={phoneImg1} title={t('section1Title')}>
        <TrackedSection sectionName="BiometricPage IntroSection">
          <p>{t('section1Para1')}</p>
          <p>{t('section1Para2')}</p>
          <p>{t('section1Para3')}</p>
        </TrackedSection>
      </OverlapBoxTechno>

      <OverlapBoxTechno img={phoneImg2} title={t('section2Title')}>
        <TrackedSection sectionName="BiometricPage Liveness">
          <p>{t('section2Para1')}</p>
          <p>{t('section2Para2')}</p>
          <p>{t('section2Para3')}</p>
        </TrackedSection>
      </OverlapBoxTechno>

      <Getstarted />
      <Footer />
    </div>
  );
};

const HeaderHalf = ({ title, uris }) => (
  <div className='headerHalf-main-face'>
    <div className='headerHalf-content'>
      <p className='headerHalf-title'>{title}</p>
      <p className='headerHalf-uris'>
        Platform / <span className='uris-class'>{uris}</span>
      </p>
    </div>
  </div>
);
